import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const pdfContainerStyle = css`
  padding: ${theme.spacing(2)};
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
`;
export const hrStyle = css`
  border: none;
  border-top: 1px solid ${theme.colors.neutral[5]};
  margin-bottom: ${theme.spacing(2)};
`;

export const headingSpacingStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(2)};
`;
